// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainContainer_w0TRM {
  display: grid;
  grid-template-columns: 3fr 0px;
  transition: grid-template-columns 1.9s ease;
  width: 100%;
  height: 100%;
}

.tablesContainer_MX9m4 {
  width: 100%;
  padding: 15px;
  /* height: calc(100vh - 83px); */
  overflow-y: scroll;

  scrollbar-width: none;
  /* Firefox */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;


}

.tablesContainer_MX9m4::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari y Edge */
}

.sectionTableMore_y2iXP {
  grid-template-columns: 3fr 300px;
}

.sectionTableMoreBill_m7N6a {
  grid-template-columns: 3fr 400px;
}

.tableHeader_BbGDS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
}

.editContainer_UzOfS {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

.selectContainer_dqTiw {
  position: absolute;
  right: 0;
  top: 100%;
  width: 80px;
  display: flex;
  flex-direction: column;
  background: var(--white-background);
  border-radius: 8px;
  box-shadow: 0 2px 10px var(--_0000001a-shadow);
  width: 115px;
  z-index: 9999;
  padding: 4px;

  >div {
    width: 100%;
    padding: 8px 16px;
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    color: var(--_3-color);
    border-radius: 4px;
    box-sizing: border-box;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: var(--f5-background);
    }
  }
}

.dotsEdit_cUqsW {
  transform: rotate(90deg);
}

.headerInfoAccount_Z7rFQ {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  height: auto;
  justify-content: space-between;
  box-sizing: border-box;
  /* flex-wrap: wrap; */
  padding: 0px 0px 10px;

  .infoAccount_e6L4V {
    width: 100%;
    min-height: 60px;
    max-height: 100%;
    border: 1px solid var(--ececf1-border);
    border-radius: 12px;
    padding: 8px;
    height: 100%;
    box-sizing: border-box;

    p,
    h3 {
      margin: 0;
    }
  }

  .newTable_sLcqm {
    background-color: #ECECF1;
    color: #10A37F;
    border: 1px solid transparent;
    cursor: pointer;
  }
}

.table_l_WlD {
  width: 100%;
  border-collapse: collapse;
  font-family: "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

.table_l_WlD thead tr {
  background-color: #f3f4f6;
  text-align: left;
}

.table_l_WlD thead th {
  padding: 12px 16px;
  font-weight: 600;
  font-size: 13px;
  color: #1f2937;
  border-bottom: 1px solid #e5e7eb;
}

.table_l_WlD tbody tr {
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s ease;
}

.table_l_WlD tbody tr:hover {
  background-color: #f9fafb;
}

.table_l_WlD td {
  padding: 12px 16px;
  font-size: 14px;
  color: #4b5563;
  vertical-align: middle;
}

.table_l_WlD input[type="checkbox"] {
  width: 16px;
  height: 16px;
}

.placeholderTable__hcY_ {
  color: #9ca3af;
  font-style: italic;
}


.tableNameEditContainer_qD3h9 {
  display: flex;
  align-items: center;
  gap: 5px;

  input[disabled] {
    background-color: transparent;
    outline: none;
    border: none;
  }

  input {
    padding: 8px;
    border: none;
    outline: none;
    background-color: white;
    border-radius: 4px;
  }
}

.editButton_xlxGl {
  cursor: pointer;
}

.iconsTypeTable_robu4 {
  svg {
    fill: var(--_030303-color);
    color: var(--_030303-color);
    height: 30px;
    width: 30px;
  }
}

.iconsTypeTableWhite_bUG32{
  /* padding: 3px;
    border-radius: 4px; */
  svg {
    /* fill: var(--white-color); */
    /* color: var(--white-color); */
    height: 30px;
    width: 30px;
  }
}

.tablesContent_D6OeM {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.optionsTd_YgkQz {
  display: flex;
  flex-direction: row-reverse;
}

.optionsTr_c1m7D {
  transition: all 300ms;
}

.optionsTr_c1m7D:hover {
  zoom: 1.05;
  box-shadow:
    inset 0 6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent),
    inset 0 -6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent);
}


.optionsTr_c1m7D:hover {
  .optionsTd_YgkQz {
    .edit_hpkV3 {
      opacity: 1;
    }
  }
}

.inputWrapperHover_NCJzl {
  position: relative;
  height: 28px;
  min-width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inputWrapperHover_NCJzl:hover {
  .inputContainer_VCTqU {
    opacity: 1;
  }
}

.inputContainer_VCTqU {
  background-color: var(--_52525261-background);
  transition: all 300ms;
  width: 25px;
  border-radius: 999px;
  height: 25px;

  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.optionsPopupContainer_SkHeY {
  position: absolute;
  z-index: 9999;
  bottom: 0px;
  left: 40px;
}

.edit_hpkV3 {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: end;
  opacity: 0;
  padding: 0;

  a {
    color: var(--_073f31-color);

  }

  .dotsOptions_vPyWQ {
    cursor: pointer;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);

    img {
      width: 18px;
      height: 18px;
    }
  }
}

.transacciones_r7KOL {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100px;

  a {
    font-weight: bold;
  }

  a,
  span {
    color: var(--_073f31-color);
  }
}

.name_o5os9 {
  color: var(--_3-color);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;

  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  >div {
    display: flex;
    flex-direction: column;
  }
}

.popupContainer_lRdj0 {
  position: absolute;
  top: 0;
  overflow: hidden;
  transform: translateX(100%);
  opacity: 0;
  transition: transform 1.9s ease, opacity 1.9s ease;


}

.popupContainerVisible_QdFYW {
  transform: translateX(0);
  opacity: 1;

}

.privatePublicButton_BX3ah{
  display: flex;
  div{
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #6E6E80;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Tables/Tables.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;EAC3C,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,kBAAkB;;EAElB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;;;AAGxB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,YAAY;;EAEZ;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,6CAA6C;;IAE7C;MACE,sCAAsC;IACxC;EACF;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;;EAErB;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,sBAAsB;;IAEtB;;MAEE,SAAS;IACX;EACF;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;yBACuB;EACvB;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV;;yFAEuF;AACzF;;;AAGA;EACE;IACE;MACE,UAAU;IACZ;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,YAAY;;EAEZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,UAAU;;EAEV;IACE,2BAA2B;;EAE7B;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;;IAE3B;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;;EAEZ;IACE,iBAAiB;EACnB;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;EACV,kDAAkD;;;AAGpD;;AAEA;EACE,wBAAwB;EACxB,UAAU;;AAEZ;;AAEA;EACE,aAAa;EACb;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[".mainContainer {\n  display: grid;\n  grid-template-columns: 3fr 0px;\n  transition: grid-template-columns 1.9s ease;\n  width: 100%;\n  height: 100%;\n}\n\n.tablesContainer {\n  width: 100%;\n  padding: 15px;\n  /* height: calc(100vh - 83px); */\n  overflow-y: scroll;\n\n  scrollbar-width: none;\n  /* Firefox */\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n\n\n}\n\n.tablesContainer::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari y Edge */\n}\n\n.sectionTableMore {\n  grid-template-columns: 3fr 300px;\n}\n\n.sectionTableMoreBill {\n  grid-template-columns: 3fr 400px;\n}\n\n.tableHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.editContainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.selectContainer {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  width: 80px;\n  display: flex;\n  flex-direction: column;\n  background: var(--white-background);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px var(--_0000001a-shadow);\n  width: 115px;\n  z-index: 9999;\n  padding: 4px;\n\n  >div {\n    width: 100%;\n    padding: 8px 16px;\n    border: none;\n    background: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 14px;\n    color: var(--_3-color);\n    border-radius: 4px;\n    box-sizing: border-box;\n    transition: background-color 0.2s ease-in-out;\n\n    &:hover {\n      background-color: var(--f5-background);\n    }\n  }\n}\n\n.dotsEdit {\n  transform: rotate(90deg);\n}\n\n.headerInfoAccount {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 10px;\n  height: auto;\n  justify-content: space-between;\n  box-sizing: border-box;\n  /* flex-wrap: wrap; */\n  padding: 0px 0px 10px;\n\n  .infoAccount {\n    width: 100%;\n    min-height: 60px;\n    max-height: 100%;\n    border: 1px solid var(--ececf1-border);\n    border-radius: 12px;\n    padding: 8px;\n    height: 100%;\n    box-sizing: border-box;\n\n    p,\n    h3 {\n      margin: 0;\n    }\n  }\n\n  .newTable {\n    background-color: #ECECF1;\n    color: #10A37F;\n    border: 1px solid transparent;\n    cursor: pointer;\n  }\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \"Segoe UI\", Roboto, sans-serif;\n  font-size: 14px;\n  color: #333;\n  background-color: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.table thead tr {\n  background-color: #f3f4f6;\n  text-align: left;\n}\n\n.table thead th {\n  padding: 12px 16px;\n  font-weight: 600;\n  font-size: 13px;\n  color: #1f2937;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid #e5e7eb;\n  transition: background-color 0.2s ease;\n}\n\n.table tbody tr:hover {\n  background-color: #f9fafb;\n}\n\n.table td {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #4b5563;\n  vertical-align: middle;\n}\n\n.table input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n}\n\n.placeholderTable {\n  color: #9ca3af;\n  font-style: italic;\n}\n\n\n.tableNameEditContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  input[disabled] {\n    background-color: transparent;\n    outline: none;\n    border: none;\n  }\n\n  input {\n    padding: 8px;\n    border: none;\n    outline: none;\n    background-color: white;\n    border-radius: 4px;\n  }\n}\n\n.editButton {\n  cursor: pointer;\n}\n\n.iconsTypeTable {\n  svg {\n    fill: var(--_030303-color);\n    color: var(--_030303-color);\n    height: 30px;\n    width: 30px;\n  }\n}\n\n.iconsTypeTableWhite{\n  /* padding: 3px;\n    border-radius: 4px; */\n  svg {\n    /* fill: var(--white-color); */\n    /* color: var(--white-color); */\n    height: 30px;\n    width: 30px;\n  }\n}\n\n.tablesContent {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.optionsTd {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.optionsTr {\n  transition: all 300ms;\n}\n\n.optionsTr:hover {\n  zoom: 1.05;\n  box-shadow:\n    inset 0 6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent),\n    inset 0 -6px 12px -8px color-mix(in srgb, var(--_10a37f-background) 20%, transparent);\n}\n\n\n.optionsTr:hover {\n  .optionsTd {\n    .edit {\n      opacity: 1;\n    }\n  }\n}\n\n.inputWrapperHover {\n  position: relative;\n  height: 28px;\n  min-width: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inputWrapperHover:hover {\n  .inputContainer {\n    opacity: 1;\n  }\n}\n\n.inputContainer {\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  width: 25px;\n  border-radius: 999px;\n  height: 25px;\n\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 300ms;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n}\n\n.optionsPopupContainer {\n  position: absolute;\n  z-index: 9999;\n  bottom: 0px;\n  left: 40px;\n}\n\n.edit {\n  position: relative;\n  display: flex;\n  gap: 10px;\n  align-items: end;\n  opacity: 0;\n  padding: 0;\n\n  a {\n    color: var(--_073f31-color);\n\n  }\n\n  .dotsOptions {\n    cursor: pointer;\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n\n    img {\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100px;\n\n  a {\n    font-weight: bold;\n  }\n\n  a,\n  span {\n    color: var(--_073f31-color);\n  }\n}\n\n.name {\n  color: var(--_3-color);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  img {\n    width: 30px;\n    height: 30px;\n    object-fit: cover;\n  }\n\n  >div {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.popupContainer {\n  position: absolute;\n  top: 0;\n  overflow: hidden;\n  transform: translateX(100%);\n  opacity: 0;\n  transition: transform 1.9s ease, opacity 1.9s ease;\n\n\n}\n\n.popupContainerVisible {\n  transform: translateX(0);\n  opacity: 1;\n\n}\n\n.privatePublicButton{\n  display: flex;\n  div{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 14px;\n    color: #6E6E80;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `mainContainer_w0TRM`,
	"tablesContainer": `tablesContainer_MX9m4`,
	"sectionTableMore": `sectionTableMore_y2iXP`,
	"sectionTableMoreBill": `sectionTableMoreBill_m7N6a`,
	"tableHeader": `tableHeader_BbGDS`,
	"editContainer": `editContainer_UzOfS`,
	"selectContainer": `selectContainer_dqTiw`,
	"dotsEdit": `dotsEdit_cUqsW`,
	"headerInfoAccount": `headerInfoAccount_Z7rFQ`,
	"infoAccount": `infoAccount_e6L4V`,
	"newTable": `newTable_sLcqm`,
	"table": `table_l_WlD`,
	"placeholderTable": `placeholderTable__hcY_`,
	"tableNameEditContainer": `tableNameEditContainer_qD3h9`,
	"editButton": `editButton_xlxGl`,
	"iconsTypeTable": `iconsTypeTable_robu4`,
	"iconsTypeTableWhite": `iconsTypeTableWhite_bUG32`,
	"tablesContent": `tablesContent_D6OeM`,
	"optionsTd": `optionsTd_YgkQz`,
	"optionsTr": `optionsTr_c1m7D`,
	"edit": `edit_hpkV3`,
	"inputWrapperHover": `inputWrapperHover_NCJzl`,
	"inputContainer": `inputContainer_VCTqU`,
	"optionsPopupContainer": `optionsPopupContainer_SkHeY`,
	"dotsOptions": `dotsOptions_vPyWQ`,
	"transacciones": `transacciones_r7KOL`,
	"name": `name_o5os9`,
	"popupContainer": `popupContainer_lRdj0`,
	"popupContainerVisible": `popupContainerVisible_QdFYW`,
	"privatePublicButton": `privatePublicButton_BX3ah`
};
export default ___CSS_LOADER_EXPORT___;
